module.exports = __webpack_public_path__ + "img/27-avatar male.236fa38e.png";